__turbopack_context__.v({
  "hasFeatureDiscoveryNotification": "UserAccountDropdown-module__ACQy-W__hasFeatureDiscoveryNotification",
  "hr": "UserAccountDropdown-module__ACQy-W__hr",
  "menu": "UserAccountDropdown-module__ACQy-W__menu",
  "menuListItem": "UserAccountDropdown-module__ACQy-W__menuListItem",
  "profileLetter": "UserAccountDropdown-module__ACQy-W__profileLetter",
});
